type CalendarIconMultipleProps = {
  month: string
  date: string
  year: string
}

export const CalendarIconMultiple = ({ month, date, year }: CalendarIconMultipleProps) => {
  return (
    <svg
      className="cmp-filterable-list__events-icon cmp-filterable-list__events-icon--multiple"
      aria-hidden="true"
      width="5rem"
      height="5rem"
      viewBox="0 0 80 80"
      xmlSpace="preserve"
    >
      <title>Pictograms/calendarcard_multipledays</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="64" height="64" rx="7"></rect>
        <filter x="-3.9%" y="-3.9%" width="110.9%" height="110.9%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
        </filter>
        <rect id="path-3" x="0" y="0" width="64" height="64" rx="7"></rect>
        <filter x="-3.9%" y="-3.9%" width="110.9%" height="110.9%" filterUnits="objectBoundingBox" id="filter-4">
          <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
        </filter>
        <rect id="path-5" x="0" y="0" width="64" height="64" rx="7"></rect>
        <filter x="-3.9%" y="-3.9%" width="110.9%" height="110.9%" filterUnits="objectBoundingBox" id="filter-6">
          <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
        </filter>
      </defs>
      <g id="Pictograms/calendarcard_multipledays" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="calendarcard" transform="translate(12.000000, 0.000000)">
          <g id="shadow" fill="black" fillOpacity="1">
            <use filter="url(#filter-2)" xlinkHref="#path-1"></use>
          </g>
          <path
            d="M0,17.7777778 L64,17.7777778 L64,59 C64,61.7614237 61.7614237,64 59,64 L5,64 C2.23857625,64 3.38176876e-16,61.7614237 0,59 L0,17.7777778 L0,17.7777778 Z"
            id="bg_grey"
            fill="#F4F4F4"
          ></path>
          <path
            d="M5,0 L59,0 C61.7614237,3.50983023e-15 64,2.23857625 64,5 L64,17.7777778 L64,17.7777778 L0,17.7777778 L0,5 C-1.2263553e-15,2.23857625 2.23857625,-3.80913106e-16 5,0 Z"
            id="bg_red"
            fill="#EB0023"
          ></path>
        </g>
        <g id="calendarcard" transform="translate(6.000000, 6.000000)">
          <g id="shadow" fill="black" fillOpacity="1">
            <use filter="url(#filter-4)" xlinkHref="#path-3"></use>
          </g>
          <path
            d="M0,17.7777778 L64,17.7777778 L64,59 C64,61.7614237 61.7614237,64 59,64 L5,64 C2.23857625,64 3.38176876e-16,61.7614237 0,59 L0,17.7777778 L0,17.7777778 Z"
            id="bg_grey"
            fill="#F4F4F4"
          ></path>
          <path
            d="M5,0 L59,0 C61.7614237,3.50983023e-15 64,2.23857625 64,5 L64,17.7777778 L64,17.7777778 L0,17.7777778 L0,5 C-1.2263553e-15,2.23857625 2.23857625,-3.80913106e-16 5,0 Z"
            id="bg_red"
            fill="#EB0023"
          ></path>
        </g>
        <g id="calendardcard" transform="translate(0.000000, 12.000000)">
          <g id="shadow" fill="black" fillOpacity="1">
            <use filter="url(#filter-6)" xlinkHref="#path-5"></use>
          </g>
          <path
            d="M0,17.7777778 L64,17.7777778 L64,59 C64,61.7614237 61.7614237,64 59,64 L5,64 C2.23857625,64 3.38176876e-16,61.7614237 0,59 L0,17.7777778 L0,17.7777778 Z"
            id="bg_grey"
            fill="#F4F4F4"
          ></path>
          <path
            d="M5,0 L59,0 C61.7614237,3.50983023e-15 64,2.23857625 64,5 L64,17.7777778 L64,17.7777778 L0,17.7777778 L0,5 C-1.2263553e-15,2.23857625 2.23857625,-3.80913106e-16 5,0 Z"
            id="bg_red"
            fill="#EB0023"
          ></path>
          <text className="cmp-filterable-list__events-icon-text cmp-filterable-list__events-icon-text--month" x="32" y="14" textAnchor="middle">
            {month}
          </text>
          <text className="cmp-filterable-list__events-icon-text cmp-filterable-list__events-icon-text--date" x="32" y="46" textAnchor="middle">
            {date}
          </text>
          <text className="cmp-filterable-list__events-icon-text cmp-filterable-list__events-icon-text--year" x="32" y="60" textAnchor="middle">
            {year}
          </text>
        </g>
      </g>
    </svg>
  )
}
